import { IComponentOptions } from "angular";
import { DownloadFileDetailController } from "./controller";

export const vsComponentName = "downloadFileDetailComponent";

export const DownloadFileDetailComponentOptions: IComponentOptions = {
  controller: DownloadFileDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    downloadFileDetail: "<",
  },
};
